<div id="steps-container">
  @for (question of store.currentGameQuestions(); track question; let index = $index; let isLast = $last) {
    <div class="step">
      <div class="circle" [class.done]="index <= (store.currentQuestion()?.index ?? 0)">{{ index + 1 }}</div>
      @if (!isLast) {
        <div class="line"  [class.done]="index <= (store.currentQuestion()?.index ?? 0) - 1"></div>
      }
    </div>
  }
</div>

